module.exports = "<span class=\"success-toast\">\n  <h2 style=\"text-align: center;\">No row selected, please select a Hotspot!</h2>\n</span>\n"